import { getElecAnalysisTreeChart } from "$/api/market-monitoring/electricity-analysis.api";
import { Loader } from "$/lib/components/atoms/Loader/Loader";
import Flexbox from "$/lib/components/common/Flexbox";
import TreeGraph from "$/lib/components/graphs/TreeGraph";
import ChartsContainer from "$/lib/components/molecules/ChartsContainer";
import DisplayBox from "$/lib/components/molecules/DisplayBox";
import FiltersDisplayBox from "$/lib/components/molecules/FiltersDisplayBox";
import { RadioButtonSet } from "$/lib/components/molecules/RadioButtonSet";
import LineChartIcon from "$/lib/icons/LineChartIcon";
import type { CustomDashboardProps } from "$/lib/types/MarketMonitoring.types";
import { getDate } from "$/lib/utils/functions/date.functions";
import { cn } from "$/lib/utils/functions/misc.functions";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

type Props = {
  selectedDate: Date;
} & CustomDashboardProps;

const ElecTreeChart = ({
  selectedDate,
  id,
  isDraggable = false,
  isShowcase = false,
}: Props) => {
  const [selectedProductType, setSelectedProductType] = useState<
    "baseload" | "peakload"
  >("baseload");

  const { data, isLoading } = useQuery({
    queryKey: [
      "get-elec-analysis-tree-chart",
      selectedDate,
      selectedProductType,
    ],
    queryFn: () =>
      getElecAnalysisTreeChart({
        date: getDate(selectedDate),
        type: selectedProductType,
      }),
  });

  return (
    <DisplayBox
      title="Suivi des produits futures A+1"
      containerClassName={cn("shadow-displayBoxShadow", {
        "pointer-events-none": isShowcase,
        "w-full": isDraggable || isShowcase,
      })}
      Icon={LineChartIcon}
      theme="blue"
      id={id}
      isDraggable={isDraggable}
    >
      <ChartsContainer className="!h-[380px] gap-4">
        {isLoading ? (
          <Flexbox fullWidth fullHeight align="center" justify="center">
            <Loader height={40} width={40} />
          </Flexbox>
        ) : (
          <div className="grow overflow-hidden rounded-2xl">
            <TreeGraph data={data ?? []} />
          </div>
        )}

        <FiltersDisplayBox className="min-w-[15%]">
          <RadioButtonSet<"baseload" | "peakload">
            id="base-peak-tree-chart"
            title="Base / Peak"
            selectedId={selectedProductType}
            onChange={(id) => setSelectedProductType(id)}
            options={[
              { id: "baseload", label: "Base" },
              { id: "peakload", label: "Peak" },
            ]}
          />

          {/* <Flexbox className="w-full gap-3.5" align="stretch">
            <p className="whitespace-nowrap text-base font-semibold text-secondary">
              Settlement price
            </p>
            <Flexbox row className="gap-2" align="center">
              <p className="text-sm font-medium text-primary">52,08</p>
              <div className="h-6 w-full grow bg-gradient-to-r from-[#183E7A] to-[#6B84AA]" />
            </Flexbox>
          </Flexbox> */}
        </FiltersDisplayBox>
      </ChartsContainer>
    </DisplayBox>
  );
};

export default ElecTreeChart;
